import type { InternalAxiosRequestConfig } from 'axios';
import { getCurrentOrgSlug } from '@src/shared/utils/get-org-id';
import { useAuthStore } from '@src/core/store/auth-store';

interface CustomAxiosRequestConfig extends InternalAxiosRequestConfig {
  withOrg?: boolean;
}

export const requestInterceptor = async (config: CustomAxiosRequestConfig) => {
  const { accessToken } = useAuthStore.getState();

  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }

  if (accessToken && config.withOrg) {
    const orgSlug = getCurrentOrgSlug();
    if (orgSlug) {
      // Spreading a URLSearchParams (`{ ...usp }`) yields `{}` — its entries
      // live behind an iterator, not own enumerable properties — which would
      // silently drop every filter a caller built with `toSearchParams`.
      // Cloned rather than mutated in place, symmetric with the plain-object
      // branch below: a caller that memoizes/reuses its URLSearchParams must
      // not find `organization` baked into it afterwards.
      if (config.params instanceof URLSearchParams) {
        config.params = new URLSearchParams(config.params);
        config.params.set('organization', orgSlug);
      } else {
        config.params = { ...(config.params || {}), organization: orgSlug };
      }
    }
  }

  return config;
};
